

import React, { useState } from 'react';
import {
  Grid,
  TextField,
  Card,
} from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import { Email } from '@mui/icons-material';
import EmailSettings from 'components/SettingsComponents/EmailSettings';

function EmailPreferences() {
  const [signature, setSignature] = useState('');

  const handleSavePersonal = async () => {
    // TODO: Implement save personal settings
  };

  return (
    <Grid container spacing={3}>
      {/* Email Configuration Card */}
      
      <Grid item xs={12}>
      <br />
        <EmailSettings />
      </Grid>

    </Grid>
  );
}

export default EmailPreferences; 